import { useEffect, useState } from 'react';

import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';

const LOAD_MORE_COUNT_DESKTOP = 3;
const LOAD_MORE_COUNT = 1;

export const useLoadMoreItems = <T>(
  items: T[],
  { desktopCount = LOAD_MORE_COUNT_DESKTOP, tabletCount = LOAD_MORE_COUNT_DESKTOP, mobileCount = LOAD_MORE_COUNT } = {}
) => {
  const { desktop, tablet } = useBreakpoints();
  const [itemsToShow, setItemsToShow] = useState(0);

  useEffect(() => {
    setItemsToShow(desktop ? desktopCount : mobileCount * 2);
  }, [desktop]);

  const onClickLoadMore = () => setItemsToShow(itemsToShow + (desktop ? desktopCount : tablet ? tabletCount : mobileCount));

  const paginatedItems = items.slice(0, itemsToShow);
  const isLastPage = paginatedItems.length === items.length;

  return { items: paginatedItems, onClickLoadMore, isLastPage };
};
